module.exports = __webpack_public_path__ + "static/img/qrcode.86db6471.jpg";